export default __webpack_public_path__ + "static/media/downloadAppPrescriptionView.2c098490.png";